import React from 'react';

import { Channel } from '../../../../types/working-model';
import { ChannelAvatar } from '../../../general-ui/avatar/channel-avatar';
import images from '../../../../images';
import { resizedImage, ResizeParams } from 'utils/utils';


interface IEventLogoProps {
	logo?: string;
	channel?: Channel;
	themeLogo?: string;
	resizeParams?: ResizeParams;
}

export default function EventLogo({ logo, channel, themeLogo, resizeParams }: IEventLogoProps): JSX.Element {

	if (channel) {
		return <ChannelAvatar channel={channel} />;
	}
	const displayImage = logo || themeLogo;
	const resizedDisplayImage = resizeParams ? resizedImage(displayImage ?? images.HeaderImage, resizeParams) : displayImage;

	return <img className="navigation-logo" src={resizedDisplayImage ?? images.HeaderImage} alt={"navigation logo"} style={{ maxHeight: 48, maxWidth: 48 }} />;
}
